import React, { useState, useEffect } from "react";
import { Form, Row, Col, Modal, Button as But } from "antd";
import TextBox from "../ReportFormGenerator/TextBox/TextBox";
import Button from "../ReportFormGenerator/Button/Button";
import Idame from "../ReportFormGenerator/Idame/Idame";
import Date from "../ReportFormGenerator/Date/Date";

function TrainingSessionCreateEditModal({
  data,
  modalVisible,
  setModalVisible,
  modalHeader,
  onFinish,
  successButtonText,
  disabledList,
  buttonLoading,
  setRequestType,
}) {
  const [form] = Form.useForm();

  if (data) {
    form.setFieldsValue({ _id: data["_id"] });
    Object.keys(data).forEach((value, index) => {
      form.setFieldsValue({ value: data[value] });
    });
    
  }

  return (
    <Modal
      centered
      title={
        <h5 style={{ color: "#fff", margin: 0, fontWeight: 600 }}>
          {modalHeader}
        </h5>
      }
      open={modalVisible}
      onCancel={() => setModalVisible(false)}
      footer={null}
      closable={true}
      maskClosable={false}
    >
      <div className="AuditSection CreateAudit" style={{ padding: "10px" }}>
        <div className="ThemeForm">
          <Form
            // name="ReportForm"
            form={form}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            layout="horizontal"
            colon={false}
            onFinish={(values) => {
              if (data) {
                setModalVisible(false);
                setRequestType("EDIT");
                onFinish(values);
              } else {
                setModalVisible(false);
                setRequestType("CREATE");
                onFinish(values);
              }
            }}
            size="large"
          >
            <Idame
              form={form}
              type="name"
              url="/mdict"
              urlData={{
                typ: "TrainingSessionsMdict",
                subTyp: "idame",
                // includeAll:true,
              }}
              idName="trgSessid"
              nameName="trgSessName"
              disabled={disabledList.includes("trgSessName")}
              defaultIdValue={data ? data["trgSessid"] : null}
              defaultNameValue={data ? data["trgSessName"] : null}
              nameLabel="Training Sessions"
              nameErrorMessage="Please Select Training Sessions"
              nameRequired={false}
              namePlaceholder="Select Training Sessions"
            />

            <Date
              name="dt"
              label={"Training Date"}
              required={true}
              disabled={disabledList.includes("dt")}
              defaultValue={data ? data["dt"] : null}
              errorMessage={"Please Select  Date"}
              placeholder={"Select Date"}
            />
            <Idame
              form={form}
              type="name"
              url="/mdict"
              urlData={{ typ: "Employee", subTyp: "idame" }}
              idName="eid"
              nameName="eame"
              nameMultiSelect={true}
              disabled={disabledList.includes("eame")}
              nameLabel="Employee"
              defaultIdValue={data ? data["eid"] : null}
              defaultNameValue={data ? data["eame"] : null}
              nameErrorMessage="Please Select Employee"
              nameRequired={true}
              namePlaceholder="Select Employee"
            />

            <Date
              name="assDt"
              label={"Assesment Date"}
              required={true}
              disabled={disabledList.includes("assDt")}
              defaultValue={data ? data["assDt"] : null}
              errorMessage={"Please Select  Assessment Date"}
              placeholder={"Select Assessment Date"}
            />
            <Idame
              form={form}
              type="name"
              url="/mdict"
              urlData={{ typ: "User", subTyp: "idame" }}
              idName="evaluator"
              nameName="evalName"
              disabled={disabledList.includes("evalName")}
              nameLabel="Evaluator"
              defaultIdValue={data ? data["evaluator"] : null}
              defaultNameValue={data ? data["evalName"] : null}
              nameErrorMessage="Please Select Evaluator"
              nameRequired={true}
              namePlaceholder="Select Evaluator"
            />

            <div style={{ visibility: "hidden" }}>
              <TextBox
                form={form}
                type="input"
                name="_id"
                label="_id"
                //   disabled={disabledList.includes("subTyp")}
                required={false}
                // errorMessage="Please Enter Training Sub Type"
                defaultValue={data ? data["_id"] : null}
                //   maxChar={400}
                //   maxCharErrorMessage="Accepted only 400 Chars"
              />
            </div>
            <Button
              form={form}
              cancelButtonText={"Reset"}
              loading={buttonLoading ? buttonLoading : false}
              marginLeft="30px"
              submitButtonText={successButtonText}
            />
          </Form>
        </div>
      </div>
    </Modal>
  );
}

export default TrainingSessionCreateEditModal;
